import { StateSchema } from 'app/config/storeConfig/types';
import { Box } from 'entities/Box';

export const getBoxInfo = (state: StateSchema): Nullable<Box> => state.bookingPage.boxInfo;
